export default __webpack_public_path__ + "static/media/Employee-Tracker.b220a219.JPG";